import script from "./LicenseManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./LicenseManagement.vue?vue&type=script&setup=true&lang=js"

import "./LicenseManagement.vue?vue&type=style&index=0&id=24501466&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24501466"]])

export default __exports__